import React from "react";
import Helpers from "../../../../utils/helpers";
import RegistrationPasswordSendModal from "../../../../components/RegistrationPasswordSendModal";
import AlertModal from "../../../../components/AlertModal";
import AlertDelete from "../../../../components/AlertDelete";
import DeleteModel from "../../../../components/DeleteModal";
import FileUploadModal from "../../../../components/FileUploadModal";
import MailRecipientsModal from "../../../RetreatClosure/MailRecipientsModal";
import { RetreatHistoryDialog } from "../lifecycle/LifecycleSections";
import type { ManageRetreatApi } from "./useManageRetreat";

export function ManageRetreatModals(m: ManageRetreatApi) {
  const confirmation = m.confirmation;

  return (
    <>
      <RetreatHistoryDialog
        open={!!m.historyRetreat}
        retreat={m.historyRetreat}
        entries={m.historyEntries}
        loading={m.historyLoading}
        onClose={() => {
          m.setHistoryRetreat(null);
          m.setHistoryEntries([]);
        }}
      />

      {m.setupMailOpen && (
        <MailRecipientsModal
          show={m.setupMailOpen}
          handleClose={() => {
            m.setSetupMailOpen(false);
            m.setSetupMailRetreat(null);
          }}
          retreatDetail={m.setupMailRetreat}
          fetchRecipients={m.fetchSetupMailRecipients}
          initialMessage={m.setupMailMessage}
          actionFunction={(selectedIds, content, additionalEmails) => {
            m.setSetupMailMessage(content);
            m.sendSetupMail(selectedIds, content, additionalEmails);
          }}
          heading={
            m.isSuperAdmin
              ? "Send Email to Retreat Adminstrators and Steering Committee"
              : "Send Email to Admin"
          }
          cancel="Cancel"
          okay="SEND"
        />
      )}

      <RegistrationPasswordSendModal
        show={m.showPasswordMailModal}
        onHide={() => m.setShowPasswordMailModal(false)}
        password={m.passwordValue}
      />

      {m.contactData ? (
        <AlertDelete
          show={m.contactData}
          alertHeader="Contact Information"
          alerMessage={
            <div>
              <h5 className="mt-4">
                <strong>Contact Name :</strong> {m.detailRow?.contact_name}
              </h5>
              <p>
                <strong>Email:</strong> {m.detailRow?.contact_email || "—"}
              </p>
              <p>
                <strong>Mobile:</strong> {m.detailRow?.contact_mobile || "—"}
              </p>
            </div>
          }
          handleClose={() => m.setContactData(false)}
          buttonText="Close"
        />
      ) : null}

      {m.confirmedData ? (
        <AlertDelete
          show={m.confirmedData}
          alertHeader="Confirmed By"
          alerMessage={
            confirmation?.length ? (
              <div>
                {["Retreat Roster data", "Directory", "Program", "Closure"].map(
                  (label, idx) => (
                    <div key={label} className="mb-3">
                      <p>
                        <strong>{label}</strong>
                      </p>
                      <p>
                        <strong>Confirmed By:</strong>{" "}
                        {confirmation[idx]?.confirmedByName
                          ? `${confirmation[idx].confirmedByName} (${confirmation[idx].confirmedByEmail || "Nil"})`
                          : "Nil"}
                      </p>
                      <p>
                        <strong>Role:</strong>{" "}
                        {confirmation[idx]?.confirmedByRole || "Nil"}
                      </p>
                      <p>
                        <strong>Confirmed Date:</strong>{" "}
                        {confirmation[idx]?.ConfirmedDate
                          ? Helpers.convertUtcToTimezone(
                              confirmation[idx].ConfirmedDate,
                              "MM-DD-YYYY hh:mm:a",
                            )
                          : "Nil"}
                      </p>
                    </div>
                  ),
                )}
              </div>
            ) : (
              <div>No confirmation data available</div>
            )
          }
          handleClose={() => m.setConfirmedData(false)}
          buttonText="Close"
        />
      ) : null}

      <FileUploadModal
        show={m.showUploadModal}
        handleClose={m.handleUploadModalClose}
        rowId={m.selectedRowId || undefined}
        handleUploadSuccess={() => m.loadSection("registrationOpen")}
        fileType={m.fileType}
        onDeleteFile={() => m.loadSection("registrationOpen")}
        existingFileUrl={m.existingFileUrl}
        modalTitle={m.uploadModalTitle}
        userData={m.userData}
      />

      {m.deleteTarget ? (
        <DeleteModel
          show={Boolean(m.deleteTarget)}
          selectionDelete="temporary"
          title={`${m.deleteTarget.parishName || m.deleteTarget.title || ""} ${
            m.deleteTarget.language
              ? `(${m.deleteTarget.language[0].toUpperCase()}${m.deleteTarget.language.slice(1)})`
              : ""
          }`}
          handleClose={() => m.setDeleteTarget(null)}
          DeleteData={m.confirmDelete}
        />
      ) : null}

      {m.restoreTarget ? (
        <AlertModal
          show={Boolean(m.restoreTarget)}
          handleClose={() => m.setRestoreTarget(null)}
          message={`<h5 class="mt-2 deleteMessage">
                Are you sure to restore this Retreat?
                <h4 class="mt-3">
                  <b>${m.restoreTarget.parishName || m.restoreTarget.title || ""}</b>
                </h4>
              </h5>`}
          actionFunction={() => m.restore(m.restoreTarget!)}
          cancel="Cancel"
          okay="Okay"
          heading="ALERT!!"
        />
      ) : null}

      {m.showFreeze ? (
        <AlertModal
          show={m.showFreeze}
          handleClose={() => {
            m.setShowFreeze(false);
            m.setAlertData({});
          }}
          message={`Are you sure you want to ${
            m.alertData.value === "FREEZE" ? "UNFREEZE" : "FREEZE"
          } this retreat?`}
          actionFunction={m.retreatFreeze}
          cancel="Cancel"
          okay="Okay"
          heading="ALERT!!"
        />
      ) : null}

      <AlertModal
        show={m.showStatus}
        handleClose={m.handleCloseStatus}
        message={` <h4>Are you sure you want to ${
          m.alertData?.status === "ACTIVE" ? "DEACTIVE" : "ACTIVE"
        } this Retreat?</h4>
  <h5 class="mt-4">
    Retreat Name: <strong>${m.alertData?.parishName || ""}
    ${
      m.alertData?.language
        ? ` (${m.alertData.language[0].toUpperCase()}${m.alertData.language.slice(1)})`
        : ""
    }
    ${m.alertData?.location ? ` ${m.alertData.location[0].toUpperCase()}${m.alertData.location.slice(1)}` : ""}</strong>
  </h5>`}
        actionFunction={m.retreatChangeStatus}
        cancel="Cancel"
        okay="Okay"
        heading="ALERT!!"
        showReasonBox={m.alertData.status === "ACTIVE"}
        existingReason={m.alertData.inactiveReason || ""}
        alertData={m.alertData}
        editBox={m.editBox}
      />
    </>
  );
}
